import CookieService from '../app/cookie.service';
import StorageService from '../app/storage.service';
import { decryptData } from '../../utils/crypto';

export default function authHeader(isAdmin = true) {
    const appKey = process.env.NEXT_PUBLIC_APP_KEY;

    const userKey = isAdmin ? 'user' : 'subscriber_user';
    const tokenKey = isAdmin ? 'token' : 'subscriber_token';
     const user = decryptData(StorageService.get(userKey));
    if (!user) return {};

    const token = CookieService.get(tokenKey);
    const domainType = StorageService.get('domain-type');
    const domain = StorageService.get('domain');

    return {
        Authorization: `Bearer ${token}`,
        'X-Domain-Id': domain,
        'X-Domain-Type': domainType,
        'app-key': appKey,
    };
}
